import React from "react";
import RelatedproductSlider from "./RelatedproductSlider";

function RelatedProduct() {
  return (
    <>
      <section class="py-5">
        <div class="container">
          <div class="row text-left p-2 pb-3">
            <h4>Related Products</h4>
          </div>
          <RelatedproductSlider />
        </div>
      </section>
    </>
  );
}

export default RelatedProduct;
